import { render } from "./BuddyDetail.vue?vue&type=template&id=a359edee&scoped=true"
import script from "./BuddyDetail.vue?vue&type=script&lang=js"
export * from "./BuddyDetail.vue?vue&type=script&lang=js"

import "./BuddyDetail.vue?vue&type=style&index=0&id=a359edee&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a359edee"]])

export default __exports__